export default __webpack_public_path__ + "bf6e5ffb6b28faf5fc93cc3932cc03df.png";